module.exports = __webpack_public_path__ + "img/1440.f807bd8e.jpg";